import React, { useCallback, useState } from "react";

import SearchFormCalendar from "./search_form_calendar";
import SearchFormSort from "./search_form_sort";

// イベント並べ替え
// app/controllers/concerns/search_concern.rbと一致
const sortEventKeys = {
  poplular: "popular",
  recently: "recently",
  weekend: "weekend",
  new: "new",
  circle: "circle",
  newCircle: "new_circle",
};

const SearchForm = ({ myPref, isShowKeywordSearch }) => {
  const [keywordDisp, setKeywordDisp] = useState("");

  const _onChangeKeyword = useCallback(
    (e) => {
      setKeywordDisp(e.target.value);
    },
    [setKeywordDisp]
  );

  const sortEventFunc = useCallback(
    (sortEventKey) => {
      if (typeof window !== "undefined") {
        if (sortEventKey === sortEventKeys.poplular) {
          location.href = `/search/${myPref ? myPref.pref_key : "all"}`;
        } else {
          location.href = `/search/${
            myPref ? myPref.pref_key : "all"
          }?event_condition=${sortEventKey}`;
        }
      }
    },
    [sortEventKeys, myPref]
  );

  const eventDateFunc = useCallback(
    (dateStr) => {
      if (typeof window !== "undefined") {
        location.href = `/search/${
          myPref ? myPref.pref_key : "all"
        }?event_date=${dateStr}`;
      }
    },
    [myPref]
  );

  return (
    <div className="search-event__body">
      {isShowKeywordSearch === "true" ? (
        <div className="position-relative container mt-4 mb-4">
          <div className="row">
            <div
              id="top-search-text-form"
              className={keywordDisp ? "col-10 pr-0" : "col-12"}
            >
              <input
                type="text"
                className="m-search-textbox"
                value={keywordDisp}
                placeholder="サークルイベントを探す"
                onChange={_onChangeKeyword}
                // inputMode="search"
              />
            </div>
            {keywordDisp && (
              <div id="top-search-text-form-button" className="col-2 px-1 mt-1">
                <a
                  className="a-button a-button-primary"
                  href={`/search/${
                    myPref ? myPref.pref_key : "all"
                  }?keyword=${keywordDisp}`}
                >
                  <img src="/icons/search.svg" />
                </a>
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="container col-lg-8">
        <p className="search-event__heading">
          <img className="ls-is-cached lazyloaded" src="/assets2019/img/icon_calendar.svg" alt="" />
          日時でイベント探そう
        </p>
        <SearchFormCalendar eventDate={null} eventDateFunc={eventDateFunc} />
        <SearchFormSort
          sortEventKeys={sortEventKeys}
          sortEventFunc={sortEventFunc}
          eventDateFunc={eventDateFunc}
          eventCondition={""}
        />
      </div>
    </div>
  );
};

export default SearchForm;
